import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { Testimonials } from './components/Testimonials';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'IntelliEats — Scan Ingredients, Eat Smarter';
    // Set favicon
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp';
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <Features data-id="element-5" />
        <IngredientDemo data-id="element-6" />
        <Testimonials data-id="element-7" />
        <DownloadCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}